const pageRouter = {
  path: '/page',
  component: () => import('@/components/pages/page/index'),
  redirect: '/page/manage',
  name: 'PageManage',
  meta: { title: '页面管理', roles: ['master'], requiresAuth: true, index: 'PageManage' },
  children: [
    {
      path: 'manage',
      component: () => import('@/components/pages/page/manage'),
      meta: { title: '页面管理', roles: ['master'], requiresAuth: true, index: 'PageManage' },
    },
    {
      path: 'new/:_id',
      name: 'PageNew',
      component: () => import('@/components/pages/page/create'),
      meta: { title: '新增页面', roles: ['master'], requiresAuth: true, index: 'PageManage' }
    }
  ]
}
export default pageRouter



// WEBPACK FOOTER //
// ./src/routers/modules/page.js